import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationItem } from '../../../../../interfaces/navigation-items';
import { Router, RouterLink } from '@angular/router';
import { NavigationItemVisibilityService } from '../../../../../services/navigation-service/navigation-item-visibility.service';
import { NavigationItemClickService } from '../../../../../services/navigation-service/navigation-item-click.service';
import { CurrentNavigationItemService } from '../../../../../services/navigation-service/current-navigation-item.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DragDropService } from '../../../../../../pages/start-page/services/drag-drop.service';

@Component({
  selector: 'side-navigation-action-item',
  imports: [CommonModule, RouterLink, TranslatePipe],
  templateUrl: './child-navigation-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./child-navigation-item.component.scss'],
})
export class ChildNavigationItem {
  @Input({ required: true }) childNavigationItem!: NavigationItem;

  constructor(
    protected navigationItemClickService: NavigationItemClickService,
    protected navigationItemVisibilityService: NavigationItemVisibilityService,
    protected router: Router,
    protected currentNavigationItemService: CurrentNavigationItemService,
    protected dragDropService: DragDropService,
  ) {}

  isSelected(): boolean {
    return (
      this.currentNavigationItemService.currentNavigationItem?.name ===
      this.childNavigationItem.name
    );
  }
}
